import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import Moment from 'moment';
import ProcessingActivity from '.././activity-proccessing/processing-activity';
import { Common } from '../../../../core/common';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import { Log } from 'ng2-logger';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { UserType } from '../../../../models/enums/userType';
import * as LoginActions from '../../../../store/actions/login';
import * as CoreActions from '../../../../store/actions/core';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import EdiText from 'react-editext';
import Countdown from 'react-countdown';
import { CoursePageService } from '../../../../api/course-page-service';
import { IActivityCard } from '../../../../models/components/activity-card';
import * as Actions from '../../../../store/actions/coursePage';
import * as IframeActions from '../../../../store/actions/iFrameSource';
import CustomIframeModal from '../../../iframe/iframe-modal';
import ReactGA from 'react-ga4';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import * as EnrollmentActions from '../../../../store/actions/enrollment';
import Truncater from '../../../truncater/main';
import { Button } from '../../../ui-elements/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('ExamActivityCard');
const maxEditTextLength = 65;
let getActivityId: string;
let nowDate = new Date();

const coursePageService = new CoursePageService();
interface IObj {
    hours: any;
    minutes: any;
    seconds: any;
    completed: any;
    days: any;
}
class ExamActivityCard extends React.Component<ISignleActivityCard> {
    state = {
        nowDate: Moment(this.props.activityCard!.serverDate).format('yyyy-MM-DDTHH:mm:ss'),
        showExamIframeModalOpen: false,
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1
    };

    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        getActivityId = this.props.activityCard!.activityId!;
        this.afterSave = this.afterSave.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true });
        }
    }

    componentDidUpdate(prevProps: Readonly<ISignleActivityCard>, prevState: Readonly<{}>, snapshot?: any): void {
        if (
            this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks &&
            this.props.courseContentTermWeeks &&
            this.props.courseContentTermWeeks.length === 1
        ) {
            this.setState({ nonWeeklyCourse: true });
        }
    }

    ConnectToExamApp() {
        if (this.props.activityCard!.exam && this.props.activityCard!.exam.examSessionId) {
            ReactGA.event({
                category: window.location.host,
                action: 'G_SHOW_EXAM_CLICKED',
                label: 'G_SHOW_EXAM_CLICKED',
                nonInteraction: true
            });
            const params = {
                id: this.props.activityCard!.activityId,
                sessionId: this.props.activityCard!.exam.examSessionId,
                eId: this.props.activityCard!.enrollmentId
            };
            this.props.dispatch(LoginActions.connectToExamApp('LoadingMain', 'get', params));
        }
    }

    triggerStudentExamReportModal = () => {
        let model = {
            ActivityId: this.props.activityCard!.activityId,
            UserId: this.props.userId,
            EnrollmentId: this.props.enrollmentData!.find(x => x.activityId === this.props.activityCard!.activityId)!.enrollmentId,
            ReturnUrl: '/Exam/StudentReport?id={0}&userId={3}&enrollRef={4}'
        };
        this.props.dispatch(IframeActions.getIFrameSource(model));

        this.setState((prevState: any) => ({ ...prevState, showExamIframeModalOpen: !prevState.showExamIframeModalOpen }));
    };

    afterSave() {
        this.props.dispatch(
            getCourseContentsWeekActivitiesAction(
                this.props.coursePageClassId ? this.props.coursePageClassId : '0',
                this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
                this.props.weekOrUnitId !== '0',
                0,
                1000,
                this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
                false,
                false,
                null,
                'contentWeekActivities',
                'get',
                undefined,
                this.props.sortKey ?? '-'
            )
        );
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(
                    this.props.activityCard.activityId,
                    name,
                    'api/activity/updateActivityName',
                    'POST',
                    this.props.classId!,
                    this.afterSave
                )
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength ? name.slice(0, maxEditTextLength).toString() + '...' : name.toString(),
                editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    }

    public isExamAvailable = () => {
        if (this.props.isSimulate) {
            return false;
        }
        if (this.state.nowDate > (this.props.activityCard!.examSessionBeginDate ? this.props.activityCard!.examSessionBeginDate : '')) {
            if (
                this.state.nowDate < (this.props.activityCard!.examSessionEndDate ? this.props.activityCard!.examSessionEndDate : '') &&
                ((this.props.activityCard!.exam && this.props.activityCard!.exam.attemptCount
                    ? this.props.activityCard!.exam.attemptCount
                    : 0) <
                    (this.props.activityCard!.exam && this.props.activityCard!.exam.allowedCount
                        ? this.props.activityCard!.exam.allowedCount
                        : 0) ||
                    this.props.activityCard!.exam!.isInfinityRepeat)
            ) {
                return true;
            }
        } else {
            return false;
        }
    };

    public renderer = (params: IObj) => {
        return (
            <>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer">
                        {params.days <= 9 ? '0' + params.days : params.days} <span>{T.t('r_time_day')}</span>
                    </div>
                </div>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer">
                        {params.hours <= 9 ? '0' + params.hours : params.hours} <span>{T.t('r_time')}</span>
                    </div>
                </div>
                <div className="col-md-3 col-4">
                    <div className="countdown-timer">
                        {params.minutes < 9 ? '0' + params.minutes : params.minutes}
                        <span>{T.t('r_time_minute')}</span>
                    </div>
                </div>
            </>
        );
        // }
    };

    public countdownIsComplete = () => {
        this.setState({
            nowDate: Moment(this.props.activityCard!.serverDate)
                .add(5, 'second')
                .format('yyyy-MM-DDTHH:mm:ss')
        });
    };

    SetActive() {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ACTIVATE_EXAM_CLICKED',
            label: 'G_ACTIVATE_EXAM_CLICKED',
            nonInteraction: true
        });
        this.props.dispatch(
            CoreActions.activityTypeSetAction(this.props.activityCard!.activityType!, this.props.activityCard!.activityId!)
        );
    }

    returnFormattedDates = (iconName: string, date: Date | null | undefined, title: string, classNameAttr: string) => {
        return (
            <div className="activity-spec">
                <div className={classNameAttr}>
                    <img src={_common.GetDefaultIcons(iconName)} alt="" />
                </div>
                <div className="spec-text">
                    <span className="spec-title" tabIndex={0}>
                        {title}
                    </span>
                    <span className="spec-title-bold" tabIndex={0}>
                        {date ? Moment(date).format(_common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)) : '-'}
                    </span>
                </div>
            </div>
        );
    };

    renderCountDown = (deadline: Date, date: Date) => {
        let isDeadlinePassed = new Date(this.state.nowDate).getTime() > deadline.getTime();
        let isActivityStarted = new Date(this.state.nowDate).getTime() > date.getTime();

        let countdownComponent;

        if (isDeadlinePassed) {
            countdownComponent =
                this.props.userType === UserType.Teacher ? (
                    ''
                ) : (
                    <div className="row">
                        <span className="exam-text" tabIndex={0}>
                            <b>{T.t('r_exam_expired')}</b>
                        </span>
                    </div>
                );
        } else {
            countdownComponent = isActivityStarted
                ? this.countDown(deadline, T.t('r_add_exam_session_left_end_date'))
                : this.countDown(date, T.t('r_add_exam_session_left_begin_date'));
        }

        return (
            <div
                className="row mx-0 d-flex align-items-center"
                style={{
                    justifyContent: this.props.userType === UserType.Student && isDeadlinePassed ? 'center' : 'space-between'
                }}
            >
                {countdownComponent}
            </div>
        );
    };

    countDown = (date: Date, title: string) => {
        return (
            <>
                <div className="col-md-3 col-12">
                    <span className="countdown-title d-flex">{title}</span>
                </div>
                <Countdown
                    onComplete={this.countdownIsComplete}
                    // tslint:disable-next-line:jsx-no-lambda
                    now={() => nowDate.getTime()}
                    date={new Date(date).getTime()}
                    renderer={this.renderer}
                />
            </>
        );
    };

    renderStudentExamReportModal = () => {
        return this.state.showExamIframeModalOpen ? (
            <CustomIframeModal
                onClose={this.triggerStudentExamReportModal}
                id="examReport"
                name="examReport"
                modalName={T.t('r_menu_exam_statistics')}
                src={this.props.iFrameSource}
            />
        ) : null;
    };

    renderPassiveExamFooter = () => {
        return (
            <div className="card-footer">
                <div className="row gradient-btn-bg">
                    <div className="passive-exam-footer d-flex align-items-center  responsive-flex">
                        <a className="align-items-center pasif-btn" href="#">
                            {T.t('r_activity_status_passive')}
                        </a>
                        <p className="countdown-title d-flex responsive-flex exam-p" style={{ alignItems: 'center' }} tabIndex={0}>
                            <img
                                height={36}
                                style={{ fill: 'black' }}
                                src={_common.GetDefaultIcons('info')}
                                className="mr-2"
                                alt="passive_exam_info"
                            />
                            {T.t('r_activity_passive_exam_information')}
                        </p>

                        <Button
                            button_type="secondary"
                            size="small"
                            style={{ marginLeft: '10px' }}
                            text={T.t('r_activity_set_status_active')}
                            onClick={() => this.SetActive()}
                        />
                    </div>
                </div>
            </div>
        );
    };

    isStudentAllowedToSeeReport = () => {
        let isStudentAllowedToSeeReport;
        if (this.props.activityCard!.exam!.allowedCount > 1) {
            if (
                this.props.activityCard!.customProperty1 === 'ShowStudentReportAfterFirstAttempt:true' ||
                this.props.activityCard!.customProperty1 === 'ShowStudentReportAfterFirstAttempt:true,false'
            ) {
                if (this.props.activityCard!.exam!.attemptCount > 0) {
                    isStudentAllowedToSeeReport = true;
                }
            } else {
                isStudentAllowedToSeeReport = this.props.activityCard!.exam!.attemptCount === this.props.activityCard!.exam!.allowedCount;
            }
        } else {
            isStudentAllowedToSeeReport = false;

            if (this.props.activityCard!.exam!.attemptCount > 0) {
                isStudentAllowedToSeeReport = true;
            }
        }
        return isStudentAllowedToSeeReport;
    };

    renderCardInfoText = () => {
        let text;
        let content;
        let classNameAttr = '';
        if (!this.props.activityCard!.exam?.isInfinityRepeat) {
            if (!this.props.activityCard!.exam?.attemptCount || this.props.activityCard!.exam?.attemptCount === 0) {
                text = T.t('r_exam_view_right_count_not_started');
                classNameAttr = 'mobile-not-show';
                content = (
                    <b>
                        &nbsp;
                        {this.props.activityCard!.exam?.allowedCount ? this.props.activityCard!.exam?.allowedCount : 0}
                    </b>
                );
            } else if (this.props.activityCard!.exam?.attemptCount && this.props.activityCard!.exam?.allowedCount) {
                if (this.props.activityCard!.exam.attemptCount < this.props.activityCard!.exam?.allowedCount) {
                    text = T.t('r_exam_view_right_count_in_progress')
                        .replace('{0}', this.props.activityCard!.exam.attemptCount)
                        .replace('{1}', this.props.activityCard!.exam?.allowedCount - this.props.activityCard!.exam.attemptCount);
                    content = (
                        <b>
                            &nbsp;
                            {this.props.activityCard!.exam.attemptCount}/{this.props.activityCard!.exam?.allowedCount}
                        </b>
                    );
                } else if (this.props.activityCard!.exam.attemptCount === this.props.activityCard!.exam?.allowedCount) {
                    text = T.t('r_exam_view_right_count_completed');
                    content = (
                        <b>
                            &nbsp;
                            {this.props.activityCard!.exam.attemptCount}/{this.props.activityCard!.exam?.allowedCount}
                        </b>
                    );
                } else {
                    return '';
                }
            }
        } else {
            text = T.t('r_exam_view_infinity_right');
            content = null;
        }
        return (
            <span className={'card-info-text' + classNameAttr} tabIndex={0}>
                {text}
                {content}
            </span>
        );
    };

    renderActiveFooter = () => {
        let isShowAnswersDatePassed = this.props.activityCard!.examShowAnswerSpecifiedDate
            ? Moment.utc(this.state.nowDate).isAfter(Moment.utc(this.props.activityCard!.examShowAnswerSpecifiedDate))
            : true;

        let isStudentAllowedToSeeReport = this.isStudentAllowedToSeeReport();
        let studentExamAttemptInfo = this.props.activityCard!.exam ? this.renderCardInfoText() : '';

        return (
            <div className="card-footer xxx">
                <div className="row justify-content-end">
                    {this.props.userType === UserType.Student ? studentExamAttemptInfo : ''}
                    {this.props.userType === UserType.Teacher ||
                    this.props.userType === UserType.ProgramAdmin ||
                    this.props.userType === UserType.Admin ? (
                        Common.HasPermission(
                            SecurityContextType.Activity,
                            SecurityPermissionType.Activity_Exam_ViewExamQuestions,
                            this.props.coursePageActivityId!
                        ) && (
                            <Button
                                button_type="primary"
                                size="medium"
                                style={{ marginLeft: '10px' }}
                                text={T.t('r_exam_view')}
                                onClick={() => this.ConnectToExamApp()}
                                disabled={this.props.isSimulate}
                            />
                        )
                    ) : (
                        <div>
                            {Common.HasPermission(
                                SecurityContextType.Activity,
                                SecurityPermissionType.Activity_Exam_StudentReport,
                                this.props.coursePageActivityId!
                            ) &&
                                (this.props.userType === UserType.Student &&
                                this.props.activityCard!.allowStudentToSeeExamReport &&
                                isStudentAllowedToSeeReport &&
                                isShowAnswersDatePassed ? (
                                    <Button
                                        button_type="secondary"
                                        style={{ margin: ' 0 10px' }}
                                        size="medium"
                                        text={T.t('r_activity_processing_view_report')}
                                        onClick={() => this.triggerStudentExamReportModal()}
                                    />
                                ) : (
                                    ''
                                ))}
                            <Button
                                button_type="primary"
                                size="medium"
                                style={{
                                    marginLeft: '10px',
                                    opacity: !this.isExamAvailable() ? 0.5 : 1,
                                    cursor: !this.isExamAvailable() ? 'not-allowed' : 'pointer'
                                }}
                                disabled={!this.isExamAvailable()}
                                text={T.t('r_exam_view')}
                                onClick={() => this.ConnectToExamApp()}
                            />
                        </div>
                    )}
                </div>

                {this.renderStudentExamReportModal()}
            </div>
        );
    };

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false;
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(
                    f => f.activityId === this.props.activityCard!.prerequisiteActivityId
                );
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;
                    }
                }
            }
        }
        return isPrerequisiteCompleted;
    };

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted;
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus
            ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine
            ? this.props.activityCard!.taskDeadLine
            : this.props.activityCard!.examSessionEndDate ?? null;

        return (
            <div className="card-header">
                <div
                    className={
                        'activity-title ' +
                        (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')
                    }
                >
                    <img src={_common.GetActivityTypeIcons('exam')} alt="Exam Activity Icon" />
                    {Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                        <div title={this.props.activityCard!.name} className="visible">
                            <EdiText
                                type="text"
                                onSave={this.handleSave}
                                onCancel={event =>
                                    this.handleClick(
                                        this.state.editTextValue.length > maxEditTextLength
                                            ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                            : this.state.editTextValue.toString()
                                    )
                                }
                                onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                value={this.state.editTextValue}
                                showButtonsOnHover={true}
                                saveButtonClassName="hideEditextSaveButton"
                                cancelButtonClassName="hideEditextCancelButton"
                                validationMessage={T.t('r_forum_tree_character')}
                                // tslint:disable-next-line:jsx-no-lambda
                                validation={val => val.trim().length >= 3}
                                editOnViewClick={true}
                                submitOnEnter={true}
                                cancelOnEscape={true}
                                className={
                                    'font-weight-bold mobile-activity-title web-activity-title' +
                                    (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir'))
                                        ? ' arabic-text-direction'
                                        : '')
                                }
                                tabIndex={0}
                            />
                        </div>
                    ) : (
                        <div
                            title={this.props.activityCard!.name}
                            tabIndex={0}
                            className={
                                'visible mobile-activity-title web-activity-title' +
                                (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir'))
                                    ? ' arabic-text-direction'
                                    : '')
                            }
                            style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}
                        >
                            {this.props.activityCard?.name && <Truncater length={42} text={this.props.activityCard?.name}></Truncater>}
                        </div>
                    )}

                    <ProcessingActivity
                        externalCssClassName="ml-auto show_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />
                </div>
                <div className="activity-status">
                    {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                    <span className="badges badges-exam activity-type" tabIndex={0}>
                        {T.t('r_activity_type_Exam')}
                    </span>
                    {/* <h6 style={{ margin: 'auto' }}>
                        {this.props.activityCard?.alwaysOnTop ? '📍' : ''}

                    </h6> */}
                    {this.props.userType === UserType.Student ? (
                        <ProgressCircleStudent
                            enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted}
                            deadline={activityDeadline}
                            activityCard={this.props.activityCard}
                        />
                    ) : (
                        <ProgressCircle
                            activityCard={this.props.activityCard}
                            percent={
                                this.props.activityCard!.completedUser === 0
                                    ? 0
                                    : (this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!
                            }
                        />
                    )}
                    &nbsp;
                    <ProcessingActivity
                        externalCssClassName="hide_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />
                </div>
            </div>
        );
    };

    renderPrerequisiteBody = (isCompletedPrerequisiteActivity: boolean) => {
        return !isCompletedPrerequisiteActivity &&
            this.props.activityCard!.prerequisiteActivityId &&
            this.props.userType === UserType.Student ? (
            <>
                <hr className="bottom-border-2 mx-0" />
                <div
                    className="passive-card-body"
                    style={{
                        opacity: 0.5,
                        fontSize: '1em !important',

                        width: '100%',
                        textAlign: 'center'
                    }}
                >
                    <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>
                        lock
                    </i>
                    <h5>
                        {T.t('r_activity_restriction_by_another_message')
                            .replace('{0}', this.props.activityCard!.name)
                            .replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                    </h5>
                </div>
            </>
        ) : null;
    };

    enrollmentScoreComponent = (iconName: string, title: string, content: any) => {
        return (
            <div className="activity-spec">
                <div className="spec-icon note">
                    <img src={_common.GetDefaultIcons(iconName)} alt="" />
                </div>
                <div className="spec-text">
                    <span className="spec-title" tabIndex={0}>
                        {title}
                    </span>
                    <span className="spec-title-bold" tabIndex={0}>
                        {content}
                    </span>
                </div>
            </div>
        );
    };

    renderEnrollmentScore = () => {
        let content;
        let title;
        let iconName;
        content = T.t('r_activity_exam_exam_type_' + this.props.activityCard!.examScoringType);
        iconName = 'notpurple';
        title = T.t('r_activity_exam_grading_type');
        let examShowAnswerSpecifiedDate = this.props.activityCard!.examShowAnswerSpecifiedDate
            ? this.props.activityCard!.examShowAnswerSpecifiedDate.toString()
            : '';
        let isShowAnswersDatePassed = this.state.nowDate > examShowAnswerSpecifiedDate;

        if (this.props.userType === UserType.Student && this.props.activityCard!.enrollmentScore! > -1) {
            if (this.props.activityCard!.examShowAnswerSpecifiedDate === null || isShowAnswersDatePassed) {
                content = this.props.activityCard!.enrollmentScore;
            } else {
                content = Moment(this.props.activityCard!.examShowAnswerSpecifiedDate).format('LLL');
            }

            iconName = 'aplus';
            title = T.t('r_add_exam_score');
        }

        return this.enrollmentScoreComponent(iconName, title, content);
    };

    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();
        let footerContent = this.props.activityCard!.activeStatus === 0 ? this.renderPassiveExamFooter() : this.renderActiveFooter();
        return (
            <div className="col-12 mobile-padding card-width">
                <div className={this.props.activityCard!.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                    {this.renderCardHeader()}
                    <hr className="bottom-border-2 mobile-line" />
                    <div className="card-body">
                        <div className="row mx-0 d-flex justify-content-between ">
                            <div className="activity-spec">
                                <div className="spec-icon exam-time">
                                    <img src={_common.GetDefaultIcons('timeblue')} alt="" />
                                </div>
                                <div className="spec-text">
                                    <span className="spec-title" tabIndex={0}>
                                        {T.t('r_validation_gen_examDurationInMinutes')}
                                    </span>
                                    <span className="spec-title-bold" tabIndex={0}>
                                        {this.props.activityCard!.examDurationInMinutes + ' ' + T.t('r_time_minute')}
                                    </span>
                                </div>
                            </div>
                            {this.renderEnrollmentScore()}
                            {this.returnFormattedDates(
                                'houryellow',
                                this.props.activityCard!.examSessionBeginDate,
                                T.t('r_activity_begin_date'),
                                'spec-icon start-date'
                            )}
                            {this.returnFormattedDates(
                                'hourred',
                                this.props.activityCard!.examSessionEndDate,
                                T.t('r_activity_due_date'),
                                'spec-icon end-date'
                            )}
                        </div>
                        {this.renderPrerequisiteBody(isCompletedPrerequisiteActivity)}
                        {this.state.nowDate > (this.props.activityCard!.examSessionEndDate ?? '') &&
                        this.props.userType === UserType.Teacher ? null : (
                            <hr style={{ padding: 0, marginLeft: 0, marginRight: 0 }} className="bottom-border-2" />
                        )}
                        {this.renderCountDown(
                            new Date(this.props.activityCard!.examSessionEndDate ?? ''),
                            new Date(this.props.activityCard!.examSessionBeginDate ?? '')
                        )}
                        {this.props.activityCard!.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0 ? (
                            <>
                                <hr style={{ padding: 0, marginLeft: 0, marginRight: 0 }} className="bottom-border-2" />
                                <div className="row  mobile-not-show">
                                    <div className="col d-flex justify-content-start align-items-baseline new-activity-block">
                                        <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                                        <p className="card-info-text card-info-text-width mobile-activity-description">
                                            <b tabIndex={0}>{T.t('r_add_exam_teacher_note')}</b>
                                            <span
                                                className={
                                                    !_common.isArabic(
                                                        this.props.activityCard!.description,
                                                        document.body.getAttribute('dir')
                                                    )
                                                        ? 'arabic-text-direction'
                                                        : ''
                                                }
                                                id="instructor_note"
                                                dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description }}
                                                tabIndex={0}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                    <hr className="bottom-border-2  mobile-not-show" />
                    {!isCompletedPrerequisiteActivity &&
                    this.props.activityCard!.prerequisiteActivityId &&
                    this.props.userType === UserType.Student
                        ? null
                        : footerContent}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        userType: state.login.identitiy.userType,
        enrollmentData: state.enrollment.enrollmentData,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        activityFilters: state.coursePage.activityFilters,
        iFrameSource: state.iFrame.iFrameSource,
        userId: state.login.identitiy.userId,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey,
        isSimulate: state.login.identitiy.isSimulate
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.login.identitiy.userId === prev.login.identitiy.userId &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView;
    return ret;
};

const CExamActivityCard = connect(mapStateToProps, dispatchProps, null, { areStatesEqual })(ExamActivityCard);

export default CExamActivityCard;
